import { useCallback, useContext, useEffect, useState } from 'react';
import { TeacherAssignment, getArchivedTeacherAssignments, getTeacherAssignments } from '../api/AssignmentTeacherApi';
import ModuleContext from '../../material/_contexts/ModuleContext';
import useThrowAsyncError from '../../../hooks/useThrowAsyncError';

export default function useAssignmentsTeacher({ archived, disabled }: { archived?: boolean; disabled?: boolean } = {}) {
  const [assignments, setAssignments] = useState<TeacherAssignment[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleError = useThrowAsyncError();
  const { module } = useContext(ModuleContext);

  const fetchAssignments = useCallback(async () => {
    if (!module || disabled) return;

    setIsLoading(true);

    try {
      const fetchedAssignments = archived
        ? await getArchivedTeacherAssignments(module.id)
        : await getTeacherAssignments(module.id);
      setAssignments(fetchedAssignments);
    } catch (err) {
      handleError(err);
    } finally {
      setIsLoading(false);
    }
  }, [module, disabled, archived, handleError]);

  useEffect(() => {
    fetchAssignments();
  }, [fetchAssignments]);

  return { assignments, fetchAssignments, isLoading };
}
